module.exports = __webpack_public_path__ + "assets/live-view.png?a772a93d442a775332fb32c35432b710";